import styled from "styled-components";
import InputTel from "./InputTel";

export default styled(InputTel)`
  width:100%;
`;